export default ({messageType, email = null, notification = null}, {firstName, lastName, userId}) => {
	const newLog = {
		messageType,
		createdDateTime: new Date(),
		createdUserFirstName: firstName,
		createdUserLastName: lastName,
		createdUserId: userId
	};

	if (email !== null) newLog.email = {...email};
	else if (notification !== null) newLog.notification = {...notification};

	return newLog;
};